module.exports = __webpack_public_path__ + "assets/img/5_1360_big.b9cd5e73.jpg";